import { render } from "./NewsReleases.vue?vue&type=template&id=5c0609a0&scoped=true"
import script from "./NewsReleases.vue?vue&type=script&lang=js"
export * from "./NewsReleases.vue?vue&type=script&lang=js"

import "./NewsReleases.vue?vue&type=style&index=0&id=5c0609a0&scoped=true&lang=css"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0609a0"]])

export default __exports__